import ConsultaBase from "../shared/ConsultaBase";
import { cotherm2compConsultaConfig } from "../config/cotherm2compConsulta";

const CCoTherm2Comp = () => {
  return <ConsultaBase config={cotherm2compConsultaConfig} />;
};

export default CCoTherm2Comp;